/* @flow */
export const prefillMessageWithGroupName = (groupName: string) => {
  return `Welcome to ${groupName}! I’m looking forward to using Remind to share updates, notes, and more. Thanks for joining!`;
};
